export enum FilterType {
  MultiSelect = 'multiSelect',
  Search = 'search',
  SearchIdentityNumber = 'searchIdentityNumber',
  Date = 'date',
  Time = 'time',
  DateTime = 'dateTime',
  TimeUtc = 'timeUtc'
}

export interface LegacyValueSource {
  key: string;
  values: string[];
}

export interface TableColumn {
  name: string;
  hideValues?: string[];
  legacyValueFrom?: LegacyValueSource;
  key: string;
  styleClass?: string;
  columnClass?: string;
  filter?: FilterType;
  filterOptions?: string[];
  multiselectFilterName?: string;
  searchFilterName?: string;
  dateFilterKey?: string;
  sortEnabled?: boolean;
  valueTranslate?: string;
  type?: string;
  conditionalRenderKey?: string;
  customLogic?: string;
  tooltipText?: string;
  defaultValue?: string;
  sortKey?: string;
  // Goes through Angular's sanitiser, which keeps links and line breaks. Do not bypass it: the
  // notification text embeds client-typed values such as names and reasons (LNA-2050).
  renderInnerHtml?: boolean;
  dynamicFilterOptionsField?: string;
  dynamicFilterIdField?: string;
  dynamicFilterSourceField?: string;
  dynamicFilterSourceLabelKey?: string;
  dynamicFilterSourceIdKey?: string;
  filterOptionLabels?: Map<string, string>;
}

export interface TableFilters {
  [key: string]: {
    isOpen: boolean;
    value: string;
    resetTrigger: boolean;
  };
}
